export default () => ({
  label: { fontSize: '12px' },
  icon: {
    fontSize: '16px',
    marginLeft: '6px',
  },
  chip: { margin: '0 .5em .5em 0' },
  chipNoGutters: { margin: '0 .5em .5em 0' },
  deletableChip: { padding: '0 8px' },
  deleteIcon: {
    margin: '0 0px 0 -6px',
    height: '16px',
  },
});
